import { useState } from "react";

const useModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [actionType, setActionType] = useState(null);
  const openModal = ({ type, data = null }) => {
    setActionType({ type, data });
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setActionType(null);
  };

  return {
    isOpen,
    openModal,
    closeModal,
    actionType,
  };
};

export default useModal;
